
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'file': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M10.9752 1.6665C11.4168 1.6665 11.8418 1.8415 12.1585 2.15817L16.1752 6.18317C16.4918 6.4915 16.6668 6.9165 16.6668 7.35817V16.6665C16.6668 17.5832 15.9168 18.3332 15.0002 18.3332H4.99183C4.07516 18.3332 3.3335 17.5832 3.3335 16.6665V3.33317C3.3335 2.4165 4.0835 1.6665 5.00016 1.6665H10.9752ZM7.50016 14.9998H12.5002C12.9585 14.9998 13.3335 14.6248 13.3335 14.1665C13.3335 13.7082 12.9585 13.3332 12.5002 13.3332H7.50016C7.04183 13.3332 6.66683 13.7082 6.66683 14.1665C6.66683 14.6248 7.04183 14.9998 7.50016 14.9998ZM12.5002 11.6665H7.50016C7.04183 11.6665 6.66683 11.2915 6.66683 10.8332C6.66683 10.3748 7.04183 9.99984 7.50016 9.99984H12.5002C12.9585 9.99984 13.3335 10.3748 13.3335 10.8332C13.3335 11.2915 12.9585 11.6665 12.5002 11.6665ZM10.8335 2.9165V6.6665C10.8335 7.12484 11.2085 7.49984 11.6668 7.49984H15.4168L10.8335 2.9165Z" fill="#93A0AE"/>'
  }
})
